import {User} from "model"
import {createContext} from "react"

export const userContext = createContext<User>(null)